import {
  browserName,
  browserVersion,
  deviceType,
  osName,
  osVersion,
  mobileVendor,
  mobileModel,
} from "react-device-detect";
import { v4 as uuidv4 } from "uuid";

export interface DeviceInfo {
  deviceId: string;
  deviceType: string;
  deviceVendor?: string;
  deviceModel?: string;
  deviceOs: string;
  deviceOsVersion: string;
  deviceBrowser: string;
  deviceBrowserVersion: string;
}

const DEVICE_ID_KEY = "device_id";

export const getOrCreateDeviceId = (): string => {
  if (typeof window === "undefined") {
    return uuidv4();
  }

  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
};

export const getDeviceInfo = (): DeviceInfo => {
  const deviceId = getOrCreateDeviceId();

  return {
    deviceId,
    deviceType: deviceType || "unknown",
    deviceVendor: mobileVendor || undefined,
    deviceModel: mobileModel || undefined,
    deviceOs: osName || "unknown",
    deviceOsVersion: osVersion || "unknown",
    deviceBrowser: browserName || "unknown",
    deviceBrowserVersion: browserVersion || "unknown",
  };
};
